import _ from 'lodash';
import { useRecoilValue } from 'recoil';
import { FormattedValueWithUnit } from '../../common/formatHelper';
import { actualityAggregatedStatsSelectedAggregatedMetric } from '../store/actuality.kpi.state';
import { ActualityAggregatedHqExtendedStatsDataRow } from '../store/actuality.kpi.types';
import useActualityAggregationMetricDescriptors from './useActualityAggregationMetricDescriptors';

function useGetActualityAggregationMetricValue() {
  const aggMetric = useRecoilValue(
    actualityAggregatedStatsSelectedAggregatedMetric,
  );
  const aggMetricDescriptors = useActualityAggregationMetricDescriptors();
  const metricDescriptor = aggMetricDescriptors[aggMetric];

  return (
    row: ActualityAggregatedHqExtendedStatsDataRow,
  ): FormattedValueWithUnit => {
    const value = _.get(row, aggMetric);
    if (_.isNumber(value) && metricDescriptor.getFormatted) {
      return metricDescriptor.getFormatted(value);
    }

    const valueString = value?.toString() ?? '';
    return {
      value: valueString,
      fullString: valueString,
      unit: '',
      raw: NaN,
      unitCode: '',
    };
  };
}

export default useGetActualityAggregationMetricValue;
